import { addDoc, collection } from 'firebase/firestore';
import { db } from '../lib/firebase';

const getClientIp = async (): Promise<string> => {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 3000);

  try {
    const response = await fetch('https://api.ipify.org?format=json', {
      signal: controller.signal,
    });
    if (!response.ok) return 'unknown';
    const data = await response.json();
    return typeof data.ip === 'string' ? data.ip : 'unknown';
  } catch {
    return 'unknown';
  } finally {
    window.clearTimeout(timeout);
  }
};

export const logDemoAccess = async (): Promise<void> => {
  const ipAddress = await getClientIp();
  const payload = {
    accessed_at: new Date().toISOString(),
    ip_address: ipAddress,
  };

  const docRef = await addDoc(collection(db, 'demo_access_logs'), payload);
  console.info('[Demo] Access logged:', docRef.id, payload);
};
